// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { Link } from "react-router-dom";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";

import {
  colors,
  sizes,
  breakpoints,
  typeSet,
  uppercase,
  expandValue,
  transition,
  padding
} from "../../helpers/theme";
var $ = require("jquery");

let headerStyles = props => css`
  ${transition("all", sizes.timer + "ms")}
  position: relative;
  top: 0;
  left: 0;
  width: auto;
  color: ${colors.white};
  height: ${expandValue(sizes.space * 3)};
  margin-left: ${expandValue(sizes.space * 2)};
  ${typeSet()};
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  ${transition("all", sizes.timer * 2 + "ms")}
  a {
    pointer-events: all;
    ${transition("color", sizes.timer + "ms")}
    color: ${colors.white};
    text-decoration: none;
    display: inline-block;
    opacity: 1;
  }
  strong {
    ${transition("color", sizes.timer + "ms")}
    ${typeSet()};
    ${uppercase()};
    ${padding(
      "all",
      expandValue((sizes.space + sizes.cap) * 0.5) +
        " 0 " +
        expandValue((sizes.space - sizes.cap) * 0.5)
    )}
    margin: 0;
    font-weight: 600;
  }
  transition: height ${
    sizes.timer
  }ms cubic-bezier(0.2, 0.53, 0.55, 0.86), transform ${
  sizes.timer
}ms cubic-bezier(0.2, 0.53, 0.55, 0.86), background ${
  sizes.timer
}ms cubic-bezier(0.2, 0.53, 0.55, 0.86);
  transition-delay: ${sizes.timer}ms;
  &.Banished {
    will-change: transform, height;
    transition-delay: ${sizes.timer}ms;
    height: ${expandValue(sizes.space * 3)};
    transform: translateY(-100%);
  }
  &.Chill {
    will-change: transform, height, background;
    height: ${expandValue(sizes.space * 3)};
    a.nav-link.active:before,
    a.nav-link:hover:before {
      height: ${expandValue(sizes.space * 0.125)};
    }
  }
  @media (max-width: ${expandValue(breakpoints[0])}) {
    transform: translateY(-200%)
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    height: ${expandValue(sizes.space * 6)};
    margin-left: ${expandValue(sizes.space * 4)};
    strong {
      ${typeSet(sizes.fontSize * 1.25)}
    }
  }
`;
let HeaderStyled = styled("header")`
  ${headerStyles}
`;

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //headerHeight: '',
      scrolledTop: ""
    };

    this.resizeFn = this.handleResize.bind(this);
    this.scrollFn = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeFn);
    window.addEventListener("scroll", this.scrollFn);
    this.setState({
      lastScrollTop: 0,
      lastScrollDistance: 0
    });

    setTimeout(
      function() {
        this.handleResize();
      }.bind(this),
      200
    );
  }

  handleResize(WindowSize, event) {
    this.setState({
      windowHeight: $(window).height(),
      headerHeight: $("#Header").height(),
      scrolledTop: $(document).scrollTop(),
      footerDepth: $("#Main").height() - $("#Footer").height()
    });

    // If scrolled 96px Bashish the Nav and Header! Bring in #Top link
    // If scrolling up more than 6px, reshow chill navigation
    // Rehide if scrolling down

    //console.log("scrolledTop", this.state.scrolledTop)
    //console.log("footerHeight", this.state.footerDepth - (this.state.windowHeight*0.5))

    if (this.state.scrolledTop > this.state.lastScrollTop) {
      // SCROLLING DOWN
      this.setState({
        lastScrollDistance: 0
      });
      if (this.state.scrolledTop >= this.state.headerHeight) {
        $("#Top").removeClass("Banished");
        $("#Nav").addClass("Banished");
        $("#Header").addClass("Banished");
        if (
          this.state.scrolledTop >=
          this.state.footerDepth - this.state.windowHeight * 0.5
        ) {
          $("#Nav").removeClass("Banished");
          $("#Nav").addClass("Chill");
          $("#Header").removeClass("Banished");
        }
      }
      //console.log("lastScrollDistance",this.state.lastScrollDistance)
      //console.log("Scrolled","DOWN")
      // check if scroll down then hide navigation
      $("#Nav").removeClass("Chill");
      //$('#Header').removeClass("Chill")
    } else {
      //SCROLLING UP
      // Add to scroll up distance when scrolling down
      this.setState({
        lastScrollDistance: Math.max(0, this.state.lastScrollDistance + 1)
      });
      //console.log("lastScrollDistance",this.state.lastScrollDistance)
      //console.log("Scrolled","UP")
      // check if scroll up distance is more than 6, then show chill navigation
      if (this.state.scrolledTop <= this.state.headerHeight) {
        $("#Top").addClass("Banished");
        $("#Nav").removeClass("Banished");
        $("#Nav").removeClass("Chill");
        $("#Header").removeClass("Banished");
        //$('#Header').removeClass("Chill")
      } else {
        if (this.state.lastScrollDistance >= 6) {
          $("#Nav").removeClass("Banished");
          //$('#Header').removeClass("Banished")
          $("#Nav").addClass("Chill");
          //$('#Header').addClass("Chill")
        }
        if (this.state.scrolledTop <= this.state.footerDepth) {
          $("#Nav").removeClass("Banished");
          $("#Nav").addClass("Chill");
          $("#Header").addClass("Banished");
        }
      }
    }
    /*
    if (this.state.scrolledTop >= (this.state.headerHeight)) {
      $('#Top').removeClass("Banished")
      $('#Nav').addClass("Banished")
      $('#Header').addClass("Banished")

      if (this.state.scrolledTop > this.state.lastScrollTop){
        this.setState({
          lastScrollDistance: 0,
        })
        //console.log("lastScrollDistance",this.state.lastScrollDistance)
        //console.log("Scrolled","DOWN")
        // check if scroll down then hide navigation
        $('#Nav').removeClass("Chill")
        //$('#Header').removeClass("Chill")
      } else {
        // Add to scroll up distance when scrolling down
        this.setState({
          lastScrollDistance: Math.max(0, this.state.lastScrollDistance + 1),
        })
        //console.log("lastScrollDistance",this.state.lastScrollDistance)
        //console.log("Scrolled","UP")
        // check if scroll up distance is more than 6, then show chill navigation
        if (this.state.lastScrollDistance >= 6) {
          $('#Nav').removeClass("Banished")
          //$('#Header').removeClass("Banished")
          $('#Nav').addClass("Chill")
          //$('#Header').addClass("Chill")
        }
      }
    } else if (this.state.scrolledTop + (this.state.windowHeight / 2) >= this.state.pageHeight - this.state.footerHeight) {
      $('#Nav').removeClass("Banished")
      $('#Nav').addClass("Chill")
      $('#Header').removeClass("Banished")
    } else {
      $('#Top').addClass("Banished")
      $('#Nav').removeClass("Banished")
      $('#Nav').removeClass("Chill")
      $('#Header').removeClass("Banished")
      //$('#Header').removeClass("Chill")
    }
    */

    this.setState({
      lastScrollTop: this.state.scrolledTop
    });
  }

  handleScroll() {
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    window.removeEventListener("scroll", this.scrollFn);
  }

  render() {
    return (
      <HeaderStyled className="header" id="Header" role="banner">
        <Link to="/">
          <strong>Jesse Stewart</strong>
        </Link>
      </HeaderStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js